import { checkAndCacheAll } from './common'

export async function getBriefs (fetchFunction) {
  return checkAndCacheAll('briefs', fetchFunction)
}
